export default "__VITE_ASSET__CC8qoATF__"